<script>
    // @ts-nocheck
    import { Router, Route, navigate, useLocation } from 'svelte-navigator'
    import { fly, fade, slide } from 'svelte/transition'
    import searchlogo from '../assets/pictures/search.svg'
    import { clickOutside, sortBy, formatCUIT, getDateObj } from '$lib/utils'
    import {
        buildFilterCompilator,
        isoDateFilterTimestamp,
        multiKeyFilter,
    } from '$lib/services/dynamicFilters'
    import { API_URL, ENV } from '$lib/conf'
    import dictionaries from '$lib/stores/dictionaries'
    import user from '$lib/stores/user'
    import { writable } from 'svelte/store'
    import provider from '$lib/stores/provider'
    import waitingDocuments from '$lib/stores/countWaiting'
    import { currencyFormatter } from '$lib/utils'
    import { onMount, onDestroy } from 'svelte'
    import { Tranfer } from '$lib/services/interfaces'
    import { db } from '$lib/services/db'
    import { liveQuery } from '$lib/services/livequery'
    import TopBar from '$lib/components/layout/TopBar.svelte'
    import {
        Banner,
        ScrollBox,
        Typography,
        TertiaryButton,
        FormBoxContainer,
        DatatableX as Datatable,
        FormBoxRow,
        FormBoxCell,
        BackDrop,
        SelectX,
        Row,
        Column,
        InputFile,
        InputText,
        InputTag,
        Alert,
        Spinner,
        Skeleton,
        Paginator,
        Chip,
        Button,
    } from '$lib/components/UI'
    import InputDate from '$lib/components/UI/InputDate.svelte'
    import { SyncOutline } from '$lib/components/Icons'
    import { default as filterIcon } from '../assets/pictures/f28-filter-funnel.svg'
    import { default as notFoundDoc } from '../assets/pictures/f64-printer.svg'
    import Close from '$lib/components/Icons/custom/Close.svelte'
    import Tranf from '$lib/components/Icons/custom/Transfer.svelte'
    import TranferTableHeader from '$lib/custom/components/TranferTableHeader.svelte'
    let dynamicFilter = [] // Arreglo de tuplas [assert<Bool>, filter<Function>]
    let showFilters = false
    let dataFilter = {
        fc_desde: 0,
        fc_hasta: 0,
    }

    let currentPage
    function getDate(date, type = 'locale') {
        if (typeof date === 'number') {
            let tmpDate = new Date(date * 1000)
            if (type === 'locale') {
                return `${String(tmpDate.getDate()).padStart(2, '0')}/${String(tmpDate.getMonth() + 1).padStart(2, '0')}/${tmpDate.getFullYear()}`
            } else if (type === 'iso') {
                return `${tmpDate.getFullYear()}-${String(tmpDate.getMonth() + 1).padStart(2, '0')}-${String(tmpDate.getDate()).padStart(2, '0')}`
            } else {
                return ''
            }
        } else {
            return ''
        }
    }
    const refStates = {}
    let sortDirective = writable(['fecha_comprobante'])
    const tranfers = liveQuery(db.tranfers, Tranfer)
    const location = useLocation()
    const getRegex = (v, f = '') => {
        return new RegExp(v, f)
    }
    const filterCompilator = buildFilterCompilator((t) =>
        t.where('cuit').equals($user?.defaultAccount)
    )
    function search(val) {
        currentPage = 1
        dynamicFilter = [
            [
                true, //   Assert (default search)
                (f) =>
                    f.filter((item) => {
                        // Custom filter (default search)
                        return (
                            [
                                'fecha_comprobante',
                                'nro_tranferencia',
                                'banco',
                                'importe',
                            ].some((x) =>
                                getRegex(
                                    `${val.replace(/[^\x00-\x7F]+/g, '.')}`,
                                    'i'
                                ).test(item[x])
                            ) || getRegex(val).test(getDate(item.fecha))
                        )
                    }),
            ],
        ]
        if (val == '') {
            clearFilter()
        }
    }
    let inputValue = ''
    $: visible = $location.pathname !== '/home/vouchers'
    const clearFilter = (_) => {
        inputValue = ''
        dynamicFilter = [] // clear filters
    }
    const autorefresh = setInterval((_) => {
        tranfers.sync({})
    }, 300000)

    onMount((_) => {
        autorefresh
        setTimeout((_) => {
            tranfers.sync({})
        }, 1500)
    })

    onDestroy((_) => {
        clearInterval(autorefresh)
    })
    let dataForm = {}
    $: if ($provider || dataForm) {
        dataForm.email = $provider.data.email_dp
    }

    let validOC = true
    let ocInp = ''
    let paginatorObj = {}
    $: if (showFilters === true) {
        dynamicFilter = [
            multiKeyFilter(dataFilter?.fecha || '', ['fecha']),
            isoDateFilterTimestamp(
                [dataFilter?.fc_desde || null, dataFilter?.fc_hasta || null],
                'fecha'
            ),
        ]
    }
    $: if (showFilters === false) {
        clearFilter()
    }
    $: tranfers.liveQuery(filterCompilator(dynamicFilter, $sortDirective)) // Reactive filter
</script>

<div
    style="width: 100%; display: flex; flex-direction:column; align-items: center; gap: 20px; position: relative"
>
    <Router primary={false}>
        <!-- svelte-ignore a11y-click-events-have-key-events -->
        <FormBoxContainer title="Tranferencias" icon={Tranf}>
            <svelte:fragment slot="option">
                <!-- <img width="32px" src={filterIcon} alt=""> -->
                <span
                    on:click={(_) =>
                        tranfers.sync({ cuit: $user?.defaultAccount })}
                    title="Sincronizar"
                >
                    <SyncOutline size={25} />
                </span>
                <span on:click={(_) => (showFilters = !showFilters)}>
                    {#if !showFilters}
                        <img
                            src={filterIcon}
                            title="Filtros"
                            width="25px"
                            alt="Filtros"
                        />
                    {:else}
                        <Close color="#C5281C" />
                    {/if}
                </span>
            </svelte:fragment>
            {#await tranfers.init()}
                <span
                    style="position: relative;width: 100%; height: 150px; display: flex; justify-content: center; align-items:center"
                >
                    <Spinner />
                </span>
            {:then _}
                {#if showFilters}
                    <span style="padding: 24px">
                        <!-- <Typography type="subhead">Identificador</Typography>
                        <Row>
                            <InputText on:keyup={_ => currentPage = 1} bind:value={dataFilter.id}/>
                        </Row> -->
                        <Typography type="subhead">Fecha</Typography>
                        <Row>
                            <InputDate
                                on:change={(_) => (currentPage = 1)}
                                label="Desde"
                                bind:value={dataFilter.fc_desde}
                            />
                            <InputDate
                                on:change={(_) => (currentPage = 1)}
                                label="Hasta"
                                bind:value={dataFilter.fc_hasta}
                            />
                        </Row>
                        {#if !([dataFilter.fc_desde, dataFilter.fc_hasta].every((t) => t !== undefined && typeof t === 'string' && t !== '') && dataFilter.fc_hasta.localeCompare(dataFilter.fc_desde) !== -1)}
                            <Alert type="error"
                                >"Hasta" debe ser posterior a "Desde"</Alert
                            >
                        {/if}
                        <p>
                            Resultados totales: <strong
                                >{$tranfers.length}</strong
                            >
                        </p>
                        <!-- <Chip color="grey">Resultados totales: {$tranfers.length}</Chip> -->
                    </span>
                {:else}
                    <span class="search">
                        <img src={searchlogo} alt="" draggable="false" />
                        <input
                            type="search"
                            placeholder="Buscar"
                            bind:value={inputValue}
                            on:input={(_) => search(inputValue)}
                        />
                    </span>
                {/if}
                <Datatable
                    data={tranfers}
                    bind:pagination={paginatorObj}
                    bind:currentPage
                    bind:sortDirective
                    waitingSignals={waitingDocuments}
                    schema={{
                        fecha_comprobante: {
                            label: 'Fecha',
                            value: i => {return getDateObj(i.fecha_comprobante)?.getTime() },
                            render: (_, i) => i.fecha_comprobante,
                            virtual: true
                        },
                        nro_tranferencia: { label: 'No. de Transferencia' },
                        banco: { label: 'Banco' },
                        importe: {
                            label: 'Importe',
                            render: n => n > 0 ? currencyFormatter({ n, lang: 'es-AR', type: 'ARS' }) : '...'
                        }
                    }}
                >
                    <svelte:fragment slot="endOfRow" let:item={transfer}>
                        <TertiaryButton
                            label="Ver detalle"
                            on:click={(_) => navigate(`vouchers/${transfer.id}`, {
                                state: {
                                    ref: '/home/vouchers',
                                },
                            })}
                        />
                    </svelte:fragment>
                    <svelte:fragment slot="noContent">
                        <img
                            src={notFoundDoc}
                            height="75px"
                            alt=""
                            style="margin: 0;padding:0; width: auto"
                        />
                        <Typography style="margin: 0; padding: 0" type="body">No se encontraron Comprobantes.</Typography>
                    </svelte:fragment>
                </Datatable>
            {/await}
        </FormBoxContainer>
        {#if ($tranfers || []).length > 0}
            <Paginator {...paginatorObj} bind:currentPage />
        {/if}
        <Route path="/:id" let:params>
            <BackDrop style="z-index: 999999; position: fixed" {visible}>
                <div
                    class="drawer"
                    transition:fly={{ x: 50 }}
                    use:clickOutside
                    on:clickout={(_) => navigate('/home/vouchers')}
                >
                    <TopBar
                        title="Detalle de Comprobante"
                        on:back={(_) => navigate($location?.state?.ref || -1)}
                    >
                        {#await tranfers.get(params.id)}
                            <Spinner />
                        {:then tranfer}
                            <div
                                transition:fade|local
                                style="position: absolute;width: 100%; height: 100%; display: flex; flex-direction: column; position: relative"
                            >
                                <ScrollBox
                                    width="100%"
                                    height="calc(100% - 43px)"
                                >
                                    <span
                                        style="padding:32px 70px; gap: 14px; display: flex; flex-direction: column"
                                    >
                                        <FormBoxContainer
                                            title="Información del Comprobante de Transferencia"
                                        >
                                            <FormBoxRow>
                                                <FormBoxCell
                                                    label="Fecha"
                                                    value={tranfer.fecha_comprobante}
                                                />
                                                <FormBoxCell
                                                    label="Banco"
                                                    value={tranfer.banco}
                                                />
                                                <FormBoxCell
                                                    label="CBU"
                                                    value={tranfer.cbu}
                                                />
                                            </FormBoxRow>
                                            <FormBoxRow>
                                                <FormBoxCell
                                                    label="CUIT"
                                                    value={tranfer.cuit}
                                                />
                                                <FormBoxCell
                                                    label="Denominación"
                                                    value={tranfer.denominacion}
                                                />
                                            </FormBoxRow>
                                            <FormBoxRow>
                                                <FormBoxCell
                                                    label="Nro. de Tranferencia"
                                                    value={tranfer.nro_tranferencia}
                                                />
                                                <FormBoxCell
                                                    label="Tipo de Tranferencia"
                                                    value={tranfer.tipo_tranferencia}
                                                />
                                                <FormBoxCell
                                                    label="Nro. Red"
                                                    value={tranfer.nro_red}
                                                />
                                            </FormBoxRow>
                                            <FormBoxRow>
                                                <FormBoxCell
                                                    label="Concepto"
                                                    value={tranfer.concepto}
                                                />
                                                <FormBoxCell
                                                    label="Motivo"
                                                    value={tranfer.motivo}
                                                />
                                            </FormBoxRow>
                                            <FormBoxRow>
                                                <FormBoxCell
                                                    label="Importe"
                                                    value={tranfer.importe
                                                        ? currencyFormatter({
                                                              n: tranfer.importe,
                                                              lang: 'es-AR',
                                                              type: 'ARS',
                                                          })
                                                        : '...'}
                                                />
                                            </FormBoxRow>
                                            {#if ENV.DEV}
                                                <FormBoxRow>
                                                    <FormBoxCell>
                                                        <a
                                                            href={`https://athentotst.lacaja.com.ar/file/view/${params.id}`}
                                                            target="_blank"
                                                            >{`https://athentotst.lacaja.com.ar/file/view/${params.id}`}</a
                                                        >
                                                    </FormBoxCell>
                                                </FormBoxRow>
                                            {/if}
                                        </FormBoxContainer>
                                        <span class="buttonSet">
                                            <Button
                                                label="Descargar"
                                                style="width: 100%"
                                                on:click={(_) =>
                                                    window.open(tranfer.link)}
                                            />
                                        </span>
                                    </span>
                                </ScrollBox>
                            </div>
                        {:catch}
                            <Alert type="error"
                                >La comprobante no existe o no tienes permisos
                                para verla.</Alert
                            >
                        {/await}
                    </TopBar>
                </div>
            </BackDrop>
        </Route>
    </Router>
</div>

<style>
    .drawer {
        position: absolute;
        min-width: 500px;
        width: 100%;
        max-width: 978px;
        right: 0;
        top: 0;
        height: 100%;
        background-color: #f6f6f6;
    }
    .search {
        width: 100%;
        height: 72px;
        position: relative;
        display: flex;
        flex-direction: row;
        gap: 15px;
        align-items: center;
        padding: 0 25px;
        justify-content: flex-start;
    }
    .search input {
        border-style: none;
        outline: none;
        font-size: 17px;
        width: 100%;
    }

    .buttonSet {
        display: flex;
        flex-direction: row;
        gap: 10px;
    }
</style>
